import { SchemaType } from '$shared/constants/SchemaType';
import { formatMillisecondsToReadableTime } from '$shared/helpers/date';
import type { ILicenseSourceStatus } from '$shared/interfaces/api/ILicenseSourceStatus';
import { schemaData } from '$shared/lib/data/SchemaData';
import BaseModel from './BaseModel';

export class LicenseSourceStatusModel extends BaseModel<ILicenseSourceStatus> {
  public get issue(): string {
    return this.response?.issue;
  }

  public get averageProcessingTime(): number {
    return this.response?.averageProcessingTime;
  }

  public get averageFailureRate(): number {
    return this.response?.averageFailureRate;
  }

  public get sourceIssueDesc(): string {
    if (!this.issue) return '';

    return schemaData.getSchemaLabel(SchemaType.SourceIssue, this.issue);
  }

  public get parsedAverageProcessingTime(): string {
    if (this.averageProcessingTime)
      return formatMillisecondsToReadableTime(this.averageProcessingTime);

    return 'NA';
  }
}
